import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import OrderDetail from '../OrderDetail';
import { orderPath } from './pickLogic';

// /orders/:orderId. Refresh and the browser back button keep the picker on the order.
// The list passes the order row (shown until the live copy loads) and its own URL,
// so "Back to Orders" returns to the same filters.
const OrderDetailRoute = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || '/orders';
  const passedOrder = location.state?.order;

  const handleBack = (flash) => {
    navigate(from, flash ? { state: { flash } } : undefined);
  };

  const handleOpenOrder = (order) => {
    navigate(orderPath(order.id), { state: { order, from } });
  };

  return (
    // Keyed so moving to the next order starts with fresh scan state
    <OrderDetail
      key={orderId}
      orderId={orderId}
      initialOrder={passedOrder && passedOrder.id === orderId ? passedOrder : null}
      onBack={handleBack}
      onOpenOrder={handleOpenOrder}
    />
  );
};

export default OrderDetailRoute;
